import { useQuery } from '@tanstack/react-query';
import { fetchAuditLog, type AuditLogParams } from '@/lib/api';

/**
 * Activity timeline for a single entity. Pass exactly one of product_id /
 * order_id / customer_id; the query stays disabled until one is present.
 */
export function useAuditLog(params: AuditLogParams) {
  return useQuery({
    queryKey: ['audit-log', params],
    queryFn: () => fetchAuditLog(params),
    enabled:
      params.product_id != null ||
      params.order_id != null ||
      params.customer_id != null,
    staleTime: 10_000,
  });
}
